import { VIEW_DAY, startOfUsWeek } from '../schedule-date-ranges'

export function buildScheduleRange(viewMode, anchorDate) {
  // Pad query bounds by a day so facility-timezone midnight events near the
  // day/week cusp are still returned when the browser zone differs.
  if (viewMode === VIEW_DAY) {
    return {
      viewMode,
      anchorDate,
      from: anchorDate
        .startOf('day')
        .minus({ days: 1 })
        .toISO(),
      to: anchorDate
        .endOf('day')
        .plus({ days: 1 })
        .toISO(),
      anchorKey: anchorDate.toISODate(),
    }
  }

  const weekStart = startOfUsWeek(anchorDate)
  return {
    viewMode,
    anchorDate,
    from: weekStart
      .startOf('day')
      .minus({ days: 1 })
      .toISO(),
    to: weekStart
      .plus({ days: 6 })
      .endOf('day')
      .plus({ days: 1 })
      .toISO(),
    anchorKey: weekStart.toISODate(),
  }
}
